import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import logo2 from "../../assets/img/logo_macizo1.png";
import PropTypes from "prop-types";
import { getUser } from "../../setup/users/actions.js";
import Cover from "react-video-cover";
import vid from "../../assets/img/video.mp4";
import "./design.css";
import Swal from "sweetalert2";
import Loading from "../../views/Loading.jsx";
import { dominio } from "../../routes_backend/routes.jsx";

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      identifier: "",
      errors: {},
      isLoading: false,
      available: "",
      message: "",
      username: "",
      password: "",
      error: "",
      resizeNotifier: null,
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;

    this.setState({
      isLoading: true,
    });

    try {
      const response = await fetch(`${dominio}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      let TOKEN = "";
      if (response.status === 200) {
        const data = await response.json();

        // dataUsuariosLogin es la respuesta del login
        let dataUsuariosLogin = data;
        console.log("dataUsuariosLogin:", dataUsuariosLogin);

        TOKEN = data.session_token;

        const res = fetch(`${dominio}/getUsersLogin`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ username, password }),
        });

        res
          .then(async (res2) => {
            const data2 = await res2.json();
            let temp_Data = [];
            data2.forEach((element) => {
              let obj = {
                UserId: " ",
                U_UserId: element.U_UserId,
                Nombre: element.U_Nombre,
                Apellido: element.U_Apellido,
                email: element.U_email,
                Cargo: element.U_Cargo,
                is_available: element.U_is_available,
                GrpReporte: element.U_GrpReporte,
                RepId: element.U_RepId,
                CargoOrda: element.U_CargoOrda,
                UserCode: element.U_UserCode,
                usuarioSAP: username,
                contraseñaSAP: password, // idealmente no persistir contraseñas
              };
              temp_Data.push(obj);
            });

            this.setState(
              {
                message: "",
                isLoading: false,
                data2: temp_Data,
                data_search: data2,
                dataUsuarios: temp_Data,
              },
              () => {
                localStorage.setItem("TOKEN", TOKEN);
                localStorage.setItem(
                  "token",
                  JSON.stringify(this.state.dataUsuarios)
                );
                localStorage.setItem(
                  "DATA_USUARIOS_LOGIN",
                  JSON.stringify(dataUsuariosLogin)
                );

                this.props.history.push("/home", { dataUsuariosLogin });
              }
            );
          })
          .catch((error) => {
            console.log(error);
            this.setState({
              isLoading: false,
              message: "error in the server",
            });
          });
      } else {
        this.setState({ error: "Credenciales incorrectas", isLoading: false });

        Swal.fire({
          icon: "error",
          title: "Credenciales incorrectas",
          text: "Verifique Usuario y Contraseña",
        }).then(() => {
          window.location.reload();
        });
      }
    } catch (error) {
      this.setState({
        error: "Verifique Conexion al Servidor",
        isLoading: false,
      });

      Swal.fire({
        icon: "error",
        title: "Fallo al Iniciar Sesion",
        text: "Verifique la conexion con el servidor",
      }).then(() => {
        this.props.history.push("/home");
      });
    }
  };

  render() {
    const { isLoading, errors } = this.state;

    const videoOptions = {
      src: vid,
      autoPlay: true,
      muted: true,
      loop: true,
    };

    return (
      <div className="login-page" responsive="true">
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/sweetalert2@11"
        ></link>

        {/* VIDEO DE FONDO */}
        <div
          style={styles.style}
          className="login-bg-video"
          responsive="true"
        >
          <Cover
            videoOptions={videoOptions}
            remeasureOnWindowResize
            getResizeNotifier={(resizeNotifier) => {
              this.setState({
                resizeNotifier,
              });
            }}
          />
        </div>

        {/* CAPA OSCURA + FORM */}
        <div
          className="login-wrapper"
          style={
            document.documentElement.clientWidth > 900
              ? styles.sectionStyle
              : styles.resize
          }
        >
          <div id="text" className="text">
            {/* <h1>Macizo</h1> */}
          </div>

          <div className="col-md-10 login-col">
            <div className="content login-content" style={styles.fondo}>
              <Grid>
                <Row>
                  <Col md={6} className="login-col-inner">
                    <div
                      className="jumbotron jumbotron-fluid login-card"
                      style={styles.jumboStyle}
                    >
                      <div
                        className="jumbotron login-card-inner"
                        style={styles.jumboInner}
                      >
                        <form onSubmit={this.handleSubmit}>
                          <div className="logo-img" style={{ opacity: 0.6 }}>
                            <img src={logo2} alt="logo_image" />
                          </div>
                          <h1
                            align="center"
                            className="display-4"
                            style={{ color: "white" }}
                          >
                            Login
                          </h1>

                          {errors.form && (
                            <div className="alert alert-danger">
                              {errors.form}
                            </div>
                          )}

                          <div className="form-group">
                            <label className="labelLogin">
                              Nombre de Usuario:
                            </label>
                            <input
                              type="text"
                              name="username"
                              value={this.state.username}
                              onChange={this.handleInputChange}
                            />
                          </div>
                          <div className="form-group">
                            <label className="labelLogin">Contraseña:</label>
                            <input
                              type="password"
                              name="password"
                              value={this.state.password}
                              onChange={this.handleInputChange}
                            />
                          </div>

                          <p className="login-message">
                            <strong>{this.state.message}</strong>
                          </p>

                          <div className="form-group" align="center">
                            <button type="submit">Iniciar Sesión</button>
                          </div>
                        </form>
                      </div>

                      <footer
                        style={{ backgroundColor: "rgba(0,0,0,0)" }}
                        className="footer"
                      >
                        <Grid fluid>
                          <p
                            style={{ color: "white" }}
                            className="copyright pull-right"
                          >
                            &copy; {new Date().getFullYear()} Created by&nbsp;
                            <a href="http://macizo.com.gt"> Macizo</a>
                          </p>
                        </Grid>
                      </footer>
                    </div>
                  </Col>
                </Row>
              </Grid>

              {isLoading && <Loading />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoginForm.propTypes = {
  getUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

LoginForm.contextTypes = {};

function mapStateToProps(state) {
  return {
    user: state.user.user,
  };
}

export default connect(mapStateToProps, { getUser })(LoginForm);

const styles = {
  fondo: {
    alignItems: "left",
  },
  jumboStyle: {
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(to right bottom, rgb(0 0 0 / 50%), rgba(0, 78, 146, 0.05))",
    borderRadius: "12px",
  },
  jumboInner: {
    backgroundColor: "transparent",
    marginBottom: 0,
  },
  style: {
    backgroundSize: "cover",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
  },
  sectionStyle: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: "2.5%",
    background:
      "linear-gradient(to right bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))",
    zIndex: 2,
  },
  resize: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: "auto",
    padding: "2.5%",
    background:
      "linear-gradient(to right bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))",
    zIndex: 2,
  },
  styleForgotMessage: {
    fontSize: "1.5rem",
    cursor: "pointer",
    color: "#FEFEFE",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
